import {
  Heading4,
  Paragraph
} from 'src/components/atoms/DesignSystem/Typography/Typography'
import { Image } from 'src/components/atoms/Image'

interface ZeroStateProps {
  title: string
  description?: string | JSX.Element
  image?: string | JSX.Element
  className?: string
  cta?: JSX.Element
}

export const ZeroState = ({
  title,
  description,
  image,
  className,
  cta
}: ZeroStateProps) => {
  return (
    <div
      className={`h-full w-full flex flex-col items-center gap-5 justify-center ${className}`}
    >
      {typeof image === 'string' ? (
        <Image src={image} alt={title} width='150' height='150' />
      ) : (
        image
      )}
      <div className='text-center w-full flex flex-col items-center gap-[10px]'>
        <Heading4>{title}</Heading4>
        <Paragraph className='font-medium w-3/4 pb-3'>{description}</Paragraph>
        {cta}
      </div>
    </div>
  )
}
